import { useEffect, useState } from 'react'
import type { ZodType } from 'zod'
import type { BaseSchema } from '../schemas'

export function withParsedData<Schema extends BaseSchema>(schema: ZodType<Schema>) {
  return function <P extends object>(WrappedComponent: React.ComponentType<P & { parsedData: Schema }>) {
    return (props: P & { data: Schema }) => {
      const { data, ...restProps } = props
      const [parsedData, setParsedData] = useState<Schema | null>(null)

      useEffect(() => {
        // NOTICE: 不要在此 catch error，让外部的 react-error-boundary 捕获错误
        const parsed = schema.parse(data)
        setParsedData(parsed)
      }, [data])

      if (!parsedData) {
        return null
      }

      return <WrappedComponent {...(restProps as P)} parsedData={parsedData} />
    }
  }
}
